var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"eimg"},[_c('img',{attrs:{"src":_vm.TName.img,"alt":""}})]),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.TName.tname))])])
}
var staticRenderFns = []

export { render, staticRenderFns }